import { render, staticRenderFns } from "./NccQuestionPrayerBar.vue?vue&type=template&id=7c2eb59e&scoped=true&"
import script from "./NccQuestionPrayerBar.vue?vue&type=script&lang=js&"
export * from "./NccQuestionPrayerBar.vue?vue&type=script&lang=js&"
import style0 from "./NccQuestionPrayerBar.vue?vue&type=style&index=0&id=7c2eb59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2eb59e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2eb59e')) {
      api.createRecord('7c2eb59e', component.options)
    } else {
      api.reload('7c2eb59e', component.options)
    }
    module.hot.accept("./NccQuestionPrayerBar.vue?vue&type=template&id=7c2eb59e&scoped=true&", function () {
      api.rerender('7c2eb59e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccQuestionPrayerBar.vue"
export default component.exports